import React, { useEffect, useMemo, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Button, Checkbox, Form, Modal, Tooltip, message, Tabs } from "antd";
import { ReactComponent as InfoIcon } from "../../assets/icons/info_icon.svg";
import { ReactComponent as CircleWarning } from "../../assets/icons/Circle_Warning.svg";
import StepsProgress from "organisms/StepsProgress";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import CreatingPerformance from "./CreatingPerformance";
import moment from "moment";
import {
  getLocations,
  getMyTeamPerformanceList,
  getSupervisorList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { connect, useSelector } from "react-redux";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { isDraft } from "@reduxjs/toolkit";

const Styleddiv = styled.div`
  .breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    color: #1f243b;
  }
  .performance-management {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    cursor: pointer;
  }
  .right-icon {
    width: 10px;
    height: 10px;
    margin-bottom: 10px;
  }
  .form-split {
    display: flex;
    gap: 80px;
  }
  .input-width {
    width: 50%;
  }
  .appraisal-people {
    font-weight: 500;
    font-size: 20px;
  }
  .button-group {
    position: fixed;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
    padding: 20px;
    width: 76%;
    gap: 20px;
    bottom: 0;
    right: 20px;
  }
  .cancel-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
  }
  .next-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    border: 1px solid #c2fae5;
  }
  .people-count {
    display: flex;
    justify-content: space-between;
  }
  .appraisal-count {
    display: flex;
    gap: 15px;
  }
  .count-bgcolor1 {
    width: 136px;
    height: 25px;
    background-color: #f4f4f4;
  }
  .count-bgcolor2 {
    width: 160px;
    height: 25px;
    background-color: #f4f4f4;
    padding: 2px;
  }
  .steps-progress .step-connector {
    width: 50px !important;
  }
  .ant-steps.ant-steps-horizontal.ant-steps-label-vertical {
    width: 0% !important;
    margin-right: 30%;
    font-weight: 1000;
    padding-bottom: 20px;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px !important; /* Set Border Radius */
    padding: 24px;
  }
  .ant-modal-footer {
    border-top: none !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .cancel-modal-button {
    width: 83px;
    height: 34px;
    border: none;
    font-weight: 400;
    font-size: 16px;
  }
  .discard-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    font-weight: 400;
    font-size: 16px;
  }
  .save-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
  .modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    margin-bottom: 0;
  }
  .circle-warning-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;
const DivStyled = styled.div`
  .preference_container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
  }
  .preference_header {
    width: 60%;
    font-weight: 500;
    font-size: 20px;
  }
  .preference_total_container {
    display: flex;
    gap: 0.5rem;
  }
  .count-bgcolor1 {
    width: 136px;
    height: 30px;
    background-color: #f4f4f4;
    font-weight: 500;
    text-align: center !important;
    border-radius: 2px !important;
    color: #636980 !important;
    padding: 2px;
  }

  .count-value {
    color: black !important;
    font-weight: 500;
  }
  .count-bgcolor2 {
    width: 180px;
    height: 30px;
    background-color: #f4f4f4;
    font-weight: 500;
    text-align: center !important;
    border-radius: 2px !important;
    color: #636980 !important;
  }
`;

const tooltipStyle = {
  width: "337px",
  height: "100px",
  borderRadius: "8px",
  padding: "8px 8px",
  fontSize: "14px",
  background: "#E2E2E8",
  color: "#1F243B",
  border: "1px solid #ddd",
};

const PerformanceContract = ({
  isEditing,
  setEditPerformance = () => {},
  editData,
  supervisorList,
  userInfo,
  selectedRecord,
  setActiveKey = () => {},
  activeKey,
  isDraft = false,
  setIsDraft = () => {},
}) => {
  useEffect(() => {
    if (editData) {
    }
  }, [editData]);
  const history = useHistory();
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [step, setStep] = useState(0);
  const [form] = Form.useForm();
  const userDataList = useSelector((state) => getUserList(state)) || [];
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({
    contractName: "",
    type: "",
    startDate: "",
    endDate: "",
    competencyQC: [],
    serviceline: [],
    subserviceline: [],
    location: [],
    grade: [],
    managingoffice: [],
    leveldepartmentname: [],
  });

  const [editTab, setEditTab] = useState(1);
  const [employeeModal, setEmployeeModal] = useState(false);
  const [overAllAppraiseeData, setOverAllAppraiseeData] = useState([]);
  const [editoverAllAppraiseeData, seteditOverAllAppraiseeData] = useState([]);
  const [overallAppraiseeOptions, setOverAllAppraiseeOptions] = useState({
    location: new Set(),
    grade: new Set(),
    competencyQC: new Set(),
    serviceline: new Set(),
    subserviceline: new Set(),
    managingoffice: new Set(),
    leveldepartmentname: new Set(),
  });
  const [contractNameList, setcontractNameList] = useState([]);
  const [stepData, setStepData] = useState(
    isEditing ? updateData(editData[0]?.individual_appraisals) : {}
  );
  const { state } = useLocation();
  const activeTab = state?.activeTab;
  const locationList = useSelector(getLocations);
  const myteamperformancelist = useSelector(getMyTeamPerformanceList);

  const filteredmyteamperformancelist = useMemo(() => {
    return (
      myteamperformancelist?.filter(
        (item) => item?.contractid?.toString() === editData?.toString()
      ) || []
    );
  }, [editData]);

  const appraisalEmailSet = new Set(
    filteredmyteamperformancelist[0]?.individual_appraisals?.map(
      (a) => a.apraiseemailid
    )
  );

  const mergedFilteredUsers = userDataList.filter((user) =>
    appraisalEmailSet.has(user.userid)
  );

  const getEmployeeList = useMemo(() => {
    return supervisorList?.find((item) => userInfo.userid === item.userid);
  }, [supervisorList, userInfo.userid]); // Runs only when `supervisorList` or `userInfo.userid` changes

  const getAllAppraiseeData = useMemo(() => {
    const appraiseeList = userDataList?.filter(
      (item) =>
        item?.statusid === "1" &&
        item?.appraisalInformation?.some(
          (info) => info.appraiser === userInfo?.userid
        )
    );
    return appraiseeList;
  }, [userDataList, getEmployeeList]);

  function updateData(apiData) {
    return apiData?.reduce((acc, user) => {
      const {
        id,
        apraiseename,
        apraiseemailid,
        upcomingappraisalperiod,
        technicalassessment,
        appraisarmailid,
        appraiseeroletype,
      } = user;

      acc[apraiseemailid] = {
        ...acc[apraiseemailid], // Preserve previous values if they exist
        upcoming_appraisal_period: {
          ...acc[apraiseemailid]?.upcoming_appraisal_period,
          ...upcomingappraisalperiod, // Update from API
        },
        technical_assessment: {
          ...acc[apraiseemailid]?.technical_assessment,
          ...technicalassessment,
        },
        completedTab: Object.fromEntries(
          Object.keys(upcomingappraisalperiod || {}).map((_, index) => [
            index + 1,
            false,
          ])
        ),
        appraisarmailid: appraisarmailid || [],
        appraiseeroletype: appraiseeroletype || [],
        apraiseename: apraiseename || "",
        apraiseemailid: apraiseemailid || "",
      };

      return acc;
    }, {});
  }

  useEffect(() => {
    if (getAllAppraiseeData?.length > 0) {
      setOverAllAppraiseeData(getAllAppraiseeData);
    }
  }, [getAllAppraiseeData]);

  useEffect(() => {
    if (isEditing) {
      seteditOverAllAppraiseeData(mergedFilteredUsers);
    }
  }, [isEditing]);

  const getAppraiserData = useMemo(() => {
    return (
      getAllAppraiseeData?.flatMap((data) =>
        data?.appraisalInformation
          ?.filter((item) => item.appraisal?.toLowerCase() === "yes") // Case-insensitive match
          .map((appraisal) => ({
            ...appraisal,
            fullname: data.fullname,
            OfficeSupervisorId: data.OfficeSupervisorId,
          }))
      ) || []
    );
  }, [getAllAppraiseeData]);

  const getDataFunction = (data) => {
    const locationIds = [...new Set(data?.map((item) => item.levellocationid))];

    const filterLocations = locationIds
      .map((id) =>
        locationList?.find((location) => location.location_id === id)
      )
      .filter(Boolean);

    const formatedData = data?.reduce((acc, emp) => {
      acc.OfficeSupervisorId ||= new Set();
      acc.grade ||= new Set();
      acc.managingoffice ||= new Set();
      acc.leveldepartmentname ||= new Set();
      acc.competencyQC ||= new Set();
      acc.serviceline ||= new Set();
      acc.subserviceline ||= new Set();

      const fields = [
        "competencyQC",
        "serviceline",
        "subserviceline",
        "userid",
        "grade",
        "managingoffice",
        "leveldepartmentname",
      ];

      fields.forEach((field) => {
        acc[field] ||= new Set();
        const values = Array.isArray(emp[field]) ? emp[field] : [emp[field]];
        values.filter(Boolean).forEach((value) => acc[field].add(value));
      });

      return acc;
    }, {});

    // Rename `location_name` to `location`
    formatedData.location = [
      ...new Set(filterLocations.map((loc) => loc.location_name)),
    ];

    Object.keys(formatedData).forEach((key) => {
      if (formatedData[key] instanceof Set) {
        formatedData[key] = [...formatedData[key]];
      }
    });

    return formatedData;
  };

  useEffect(() => {
    if (!getAllAppraiseeData) return;

    const { contractName, type, startDate, endDate } = formData;

    const hasContractData = contractName || type || startDate || endDate;
    if (hasContractData) {
      setData(formData);
    } else if (getAllAppraiseeData?.length > 0) {
      const transformedData = getDataFunction(overAllAppraiseeData);
      setData(transformedData);
    }
  }, [getAllAppraiseeData, overallAppraiseeOptions, step]);

  const transformedData = useMemo(() => {
    if (!filteredmyteamperformancelist) return {};
    return {
      contractName:
        formData?.contractName ||
        filteredmyteamperformancelist[0]?.performancecontractname,
      type: formData?.type || filteredmyteamperformancelist[0]?.type,
      startDate: formData?.startDate
        ? moment(formData?.startDate)
        : moment(filteredmyteamperformancelist[0]?.submissionstartdate),
      endDate: formData?.endDate
        ? moment(formData?.endDate)
        : moment(filteredmyteamperformancelist[0]?.submissionenddate),
      managingoffice:
        formData?.managingoffice?.length > 0
          ? formData?.managingoffice
          : filteredmyteamperformancelist[0]?.country,
      competencyQC:
        formData?.competencyQC?.length > 0
          ? formData?.competencyQC
          : filteredmyteamperformancelist[0]?.competency,
      serviceline:
        formData?.serviceline?.length > 0
          ? formData?.serviceline
          : filteredmyteamperformancelist[0]?.serviceline,
      subserviceline:
        formData?.subserviceline?.length > 0
          ? formData?.subserviceline
          : filteredmyteamperformancelist[0]?.subserviceline,
      location:
        formData?.location?.length > 0
          ? formData?.location
          : filteredmyteamperformancelist[0]?.location,
      leveldepartmentname:
        formData?.leveldepartmentname?.length > 0
          ? formData?.leveldepartmentname
          : filteredmyteamperformancelist[0]?.department,
      grade:
        formData?.grade?.length > 0
          ? formData?.grade
          : filteredmyteamperformancelist[0]?.grade,
    };
  }, [getAllAppraiseeData, filteredmyteamperformancelist, formData]);

  const [getSelectedData, setGetSelectedData] = useState([]);
  const [filters, setFilters] = useState({
    location: new Set(),
    grade: new Set(),
    subserviceline: new Set(),
    serviceline: new Set(),
    competencyQC: new Set(),
    managingoffice: new Set(),
    leveldepartmentname: new Set(),
  });

  const createEmployeeLookup = (employees) => {
    const lookup = {
      location: new Set(),
      grade: new Set(),
      competencyQC: new Set(),
      serviceline: new Set(),
      subserviceline: new Set(),
      managingoffice: new Set(),
      leveldepartmentname: new Set(),
    };

    const locationIds = [
      ...new Set(employees?.map((item) => item.levellocationid)),
    ];

    const filterLocations = locationIds
      .map((id) =>
        locationList?.find((location) => location.location_id === id)
      )
      .filter(Boolean);

    employees.forEach((employee) => {
      if (Array.isArray(filterLocations)) {
        filterLocations.forEach((location) =>
          lookup.location.add(location.location_name)
        );
      }
      if (employee.grade) lookup.grade.add(employee.grade);

      if (Array.isArray(employee.managingoffice)) {
        employee.managingoffice.forEach((office) =>
          lookup.managingoffice.add(office)
        );
      } else if (employee.managingoffice) {
        lookup.managingoffice.add(employee.managingoffice);
      }

      if (Array.isArray(employee.leveldepartmentname)) {
        employee.leveldepartmentname.forEach((dept) =>
          lookup.leveldepartmentname.add(dept)
        );
      } else if (employee.leveldepartmentname) {
        lookup.leveldepartmentname.add(employee.leveldepartmentname);
      }

      if (Array.isArray(employee.competencyQC)) {
        employee.competencyQC.forEach((qc) => lookup.competencyQC.add(qc));
      } else if (employee.competencyQC) {
        lookup.competencyQC.add(employee.competencyQC);
      }

      if (Array.isArray(employee.serviceline)) {
        employee.serviceline.forEach((service) =>
          lookup.serviceline.add(service)
        );
      } else if (employee.serviceline) {
        lookup.serviceline.add(employee.serviceline);
      }

      if (Array.isArray(employee.subserviceline)) {
        employee.subserviceline.forEach((subservice) =>
          lookup.subserviceline.add(subservice)
        );
      } else if (employee.subserviceline) {
        lookup.subserviceline.add(employee.subserviceline);
      }
    });

    return lookup;
  };

  useEffect(() => {
    if (getAllAppraiseeData?.length) {
      const lookup = createEmployeeLookup(getAllAppraiseeData);
      setOverAllAppraiseeOptions(lookup);
    }
  }, [getAllAppraiseeData]);

  // useEffect(() => {
  //   if (isEditing && editoverAllAppraiseeData?.length > 0) {
  //     const updatedFilters = {
  //       location: new Set(),
  //       grade: new Set(),
  //       subserviceline: new Set(),
  //       serviceline: new Set(),
  //       competencyQC: new Set(),
  //       managingoffice: new Set(),
  //       leveldepartmentname: new Set(),
  //     };

  //     const locationMap = locationList.reduce((acc, { location_id, location_name }) => {
  //       acc[location_id] = location_name;
  //       return acc;
  //     }, {});

  //     editoverAllAppraiseeData.forEach((data) => {
  //       if (data.levellocationid && locationMap[data.levellocationid]) {
  //         updatedFilters.location.add(locationMap[data.levellocationid]);
  //       }
  //       if (data.grade) updatedFilters.grade.add(data.grade);
  //       if (data.subserviceline?.length) {
  //         data.subserviceline.forEach((item) => updatedFilters.subserviceline.add(item));
  //       }
  //       if (data.serviceline?.length) {
  //         data.serviceline.forEach((item) => updatedFilters.serviceline.add(item));
  //       }
  //       if (data.competencyQC?.length) {
  //         data.competencyQC.forEach((item) => updatedFilters.competencyQC.add(item));
  //       }
  //       if (data.managingoffice?.length) {
  //         data.managingoffice.forEach((item) => updatedFilters.managingoffice.add(item));
  //       }
  //       if (data.leveldepartmentname?.length) {
  //         data.leveldepartmentname.forEach((item) => updatedFilters.leveldepartmentname.add(item));
  //       }
  //     });
  //     console.log("final updatedFilters -->", updatedFilters)
  //       setFilters(updatedFilters);
  //   }
  // }, [isEditing,editoverAllAppraiseeData]);
  const handleSelectChange = (selectedItems, type) => {
    // Always update formData for selected type
    setFormData((prev) => ({
      ...prev,
      [type]: selectedItems,
    }));

    // If the change is for contract type only, update and return
    if (type === "type") {
      if (isEditing) {
        setData((prev) => ({
          ...prev,
          type: selectedItems,
        }));
      }
      return;
    }

    const newFilters = { ...filters, [type]: new Set(selectedItems) };

    const locationIdToNameMap = Object.fromEntries(
      locationList.map((loc) => [loc.location_id, loc.location_name])
    );

    const isMatch = (employee, key, values) => {
      if (!values.size) return true;
      if (key === "location") {
        const locName = locationIdToNameMap[employee.levellocationid];
        return values.has(locName);
      }
      const empVal = employee[key];
      return Array.isArray(empVal)
        ? empVal.some((val) => values.has(val))
        : values.has(empVal);
    };

    const updatedAppraiseeData = getAllAppraiseeData?.filter((employee) =>
      Object.entries(newFilters).every(([key, values]) =>
        isMatch(employee, key, values)
      )
    );

    const cleanedFilters = Object.fromEntries(
      Object.entries(newFilters).map(([key, values]) => {
        const validValues = new Set(
          [...values].filter((val) =>
            updatedAppraiseeData.some((emp) => {
              if (key === "location") {
                return locationIdToNameMap[emp.levellocationid] === val;
              }
              const empVal = emp[key];
              return Array.isArray(empVal)
                ? empVal.includes(val)
                : empVal === val;
            })
          )
        );
        return [key, validValues];
      })
    );

    setFilters(cleanedFilters);
    setOverAllAppraiseeData(updatedAppraiseeData);

    if (isEditing) {
      seteditOverAllAppraiseeData(updatedAppraiseeData);
    }
  };

  const handleSaveChanges = async (values) => {
    await handleSubmit("completed", values);
  };

  const handleNext = async (values) => {
    setFormData(values);
    try {
      const preferredCount = isEditing
        ? editoverAllAppraiseeData?.length
        : overAllAppraiseeData?.length;
      if (preferredCount === 0) {
        message.warning(
          "Preferred for Contract is 0. Please add appraisees before proceeding."
        );
        return;
      }
      setStep(1);
    } catch (error) {
      console.log("Validation failed", error);
    }
  };
  const showCancelModal = () => {
    setIsCancelModal(true);
    // setIsDraft(false);
  };
  const handlePerformanceClick = () => {
    history.push("/performancemanagement");
  };
  const handleModalCancel = () => {
    setIsCancelModal(false);
  };
  const handleEmpModalCancel = () => {
    setEmployeeModal(false);
  };
  const handleDiscard = () => {
    form.resetFields();
    if (typeof setEditPerformance === "function") {
      setEditPerformance(false);
    }
    setIsDraft(false);
    setIsCancelModal(false);
    history.push(`/performancemanagement`, { tabId: activeTab || "2" });
  };
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    // Only update specific fields while preserving other state values
    if (["contractName", "type", "startDate", "endDate"].includes(name)) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  // const handleFormChange = (e) => {
  //   const { name, value } = e.target;
  //   if (["contractName", "type", "startDate", "endDate"].includes(name)) {
  //     if (name === "startDate" || name === "endDate") {
  //       form.setFieldsValue({
  //         [name]: value._d,
  //       });
  //       setData((prevData) => ({
  //         ...prevData,
  //         [name]: value,
  //       }));
  //       setFormData((prevData) => ({
  //         ...prevData,
  //         [name]: value._d,
  //       }));
  //     } else {
  //       setFormData((prevData) => ({
  //         ...prevData,
  //         [name]: value,
  //       }));
  //       setData((prevData) => ({
  //         ...prevData,
  //         [name]: value,
  //       }));
  //       form.setFieldsValue({
  //         [name]: value,
  //       });
  //     }
  //   }
  // };

  const getContractNameList = async () => {
    const response = await CALL_API(`appraisal/existscontract`, "get");
    if (response.code === STATUS_CODE.SUCCESS)
      setcontractNameList(response.contractNameList);
  };

  useEffect(() => {
    getContractNameList();
  }, []);

  const validateEmployeeId = (rule, value) => {
    if (!value) return Promise.resolve(); // Skip if empty — required rule will handle it

    if (
      filteredmyteamperformancelist?.[0]?.performancecontractname !== value &&
      contractNameList.includes(value)
    ) {
      return Promise.reject("A contract with this name already exists");
    }
    return Promise.resolve();
  };

  const [initialContractName, setInitialContractName] = useState("");

  useEffect(() => {
    if (isEditing) {
      const existingName = form.getFieldValue("contractName");
      setInitialContractName(existingName);
    }
  }, [isEditing]);

  const AppraisalInformation = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [12, 12, 12, 12, 12, 12],
        fields: [
          [
            {
              id: 1,
              label: "Performance Contract Name",
              type: "text",
              name: "contractName",
              maxLength: 35,
              validationRules: [
                {
                  required: true,
                  message: "Performance Contract Name is required",
                },
                { validator: validateEmployeeId },
              ],
            },
            {
              id: 2,
              label: "Type",
              type: "select",
              name: "type",
              validationRules: [
                {
                  required: true,
                  message: "Type is required",
                },
              ],
              options: ["Yearly", "Half Yearly", "Quarterly"],
            },
          ],
          [
            {
              id: 3,
              label: "Submission Start Date",
              type: "appraisal-date",
              name: "startDate",
              validationRules: [
                {
                  required: true,
                  message: "Start Date is required",
                },
              ],
            },
            {
              id: 4,
              label: "Submission End Date",
              type: "appraisal-date",
              name: "endDate",
              validationRules: [
                {
                  required: true,
                  message: "End Date is required",
                },
              ],
            },
          ],
          [
            {
              type: "div-content",
              content: (
                <>
                  <DivStyled>
                    <div className="preference_container">
                      <div className="preference_header">
                        <p>
                          People Preference
                          <Tooltip
                            title="This is the default preference based on your appraisees' information. You can modify it as needed to align with the contract you are creating."
                            overlayInnerStyle={tooltipStyle}
                          >
                            &nbsp;
                            <InfoIcon />
                          </Tooltip>
                        </p>
                      </div>
                      <div className="preference_total_container">
                        <p className="count-bgcolor1">
                          Total Appraisee :{" "}
                          <span className="count-value">
                            {getAllAppraiseeData?.length || 0}
                          </span>
                        </p>
                        <p className="count-bgcolor2">
                          Preferred for Contract :{" "}
                          <span className="count-value">
                            {(isEditing
                              ? editoverAllAppraiseeData?.length
                              : overAllAppraiseeData?.length) || 0}
                          </span>
                        </p>
                      </div>
                    </div>
                  </DivStyled>
                </>
              ),
            },
          ],
          [
            {
              id: 5,
              label: "Country",
              type: "select",
              name: "managingoffice",
              mode: "multiple",
              setEmployeeModal: setEmployeeModal,
              options: Array.from(overallAppraiseeOptions?.managingoffice),
              validationRules: [
                {
                  required: true,
                  message: "Country is required",
                },
              ],
            },
            {
              id: 6,
              label: "Competency / QC",
              type: "select",
              mode: "multiple",
              name: "competencyQC",
              options: Array.from(overallAppraiseeOptions?.competencyQC),
              validationRules: [
                {
                  required: true,
                  message: "Competency / QC is required",
                },
              ],
            },
          ],
          [
            {
              id: 7,
              label: "Service Line",
              type: "select",
              mode: "multiple",
              name: "serviceline",
              options: Array.from(overallAppraiseeOptions?.serviceline),
              validationRules: [
                {
                  required: true,
                  message: "Service Line is required",
                },
              ],
            },
            {
              id: 8,
              label: "Sub Service Line",
              type: "select",
              mode: "multiple",
              name: "subserviceline",
              options: Array.from(overallAppraiseeOptions?.subserviceline),
              validationRules: [
                {
                  required: true,
                  message: "Sub Service Line is required",
                },
              ],
            },
          ],
          [
            {
              id: 9,
              label: "Location",
              type: "select",
              mode: "multiple",
              name: "location",
              setEmployeeModal: setEmployeeModal,
              options: Array.from(overallAppraiseeOptions?.location),
              validationRules: [
                {
                  required: true,
                  message: "Location is required",
                },
              ],
            },
            {
              id: 10,
              label: "Department",
              type: "select",
              mode: "multiple",
              name: "leveldepartmentname",
              setEmployeeModal: setEmployeeModal,
              options: Array.from(overallAppraiseeOptions?.leveldepartmentname),
              validationRules: [
                {
                  required: true,
                  message: "Department is required",
                },
              ],
            },
          ],
          [
            {
              id: 11,
              label: "Grade",
              type: "select",
              mode: "multiple",
              name: "grade",
              options: Array.from(overallAppraiseeOptions?.grade),
              setEmployeeModal: setEmployeeModal,
              validationRules: [
                {
                  required: true,
                  message: "Grade is required",
                },
              ],
            },
            {},
          ],
          [
            {
              id: 12,
              label: "Cancel",
              type: "buttongroup",
              position: "end",
              textColor: "white",
              event: "back",
              buttons: [
                {
                  label: "Cancel",
                  disabled: false,
                  loading: false,
                  btnStyle: {
                    backgroundColor: "white",
                    width: "130px",
                    height: "34px",
                    borderRadius: "8px",
                    border: "1px solid #1f243b",
                  },
                  onClick: () => {
                    if (isEditing) {
                      setEditPerformance(false);
                      setIsDraft(false);
                      history.push(`/performancemanagement`, { tabId: 2 });
                    } else {
                      showCancelModal();
                      setIsDraft(false);
                    }
                  },
                },
                {
                  label: isEditing && !isDraft ? "Save Changes" : "Next",
                  disabled: false,
                  loading: false,
                  event: "submit",
                  btnStyle: {
                    width: "130px",
                    height: "34px",
                    borderRadius: "8px",
                    backgroundColor: "#c2fae5",
                    border: "1px solid #c2fae5",
                  },
                },
              ],
            },
          ],
        ],
      },
    ],
  };

  const stepdata = [{ id: 1 }, { id: 2 }];

  const handleClickCheckbox = (e, record) => {
    const { checked } = e.target;
    setGetSelectedData((prevSelected) => {
      if (checked) {
        return [...prevSelected, record];
      } else {
        return prevSelected.filter(
          (item) => item.employeeid !== record.employeeid
        );
      }
    });
  };

  const handleSelectAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      setGetSelectedData(getAllAppraiseeData);
    } else {
      setGetSelectedData([]);
    }
  };

  const isAllChecked =
    getSelectedData.length === getAllAppraiseeData.length &&
    getAllAppraiseeData.length > 0;

  const locationMap = Object.fromEntries(
    locationList.map((loc) => [loc.location_id, loc.location_name])
  );

  const handleSubmit = async (status, values) => {
    const emailIds = Object.keys(stepData);

    const employeeIds = isEditing
      ? overAllAppraiseeData
          ?.filter((item) => !emailIds.includes(item.userid))
          .map((item) => item.userid)
      : overAllAppraiseeData.map((item) => item.userid);

    // Clone stepData and add missing entries for employeeIds
    const updatedStepData = {
      ...stepData,
      ...employeeIds?.reduce((acc, id) => {
        const user = overAllAppraiseeData.find((val) => val.userid === id);

        const upcomingAppraisalPeriod = user?.appraisalInformation
          ?.filter((info) => info.appraisal === "Yes")
          ?.reduce((periods, item, index) => {
            periods[item.roletype] = [
              {
                sno: 1,
                targetobjective: "",
                expectedoutcomes: "",
                targetdate: "",
              },
            ];
            return periods;
          }, {});

        const technicalAssessment = user?.appraisalInformation
          ?.filter((info) => info.appraisal === "Yes")
          ?.reduce((assessment, item) => {
            assessment[item.roletype] = [
              {
                sno: 1,
                objectives: "Key responsibilities (from job descriptions)",
                weightage: "",
              },
              {
                sno: 2,
                objectives: "Additional Roles / Backstopping Roles",
                weightage: "",
              },
              {
                sno: 3,
                objectives: "Strategic / Target objectives",
                weightage: "",
              },
              {
                sno: 4,
                objectives: "Actions expected from previous Appraisal",
                weightage: "",
              },
            ];
            return assessment;
          }, {});

        const completedtabs = user?.appraisalInformation
          ?.filter((info) => info.appraisal === "Yes")
          .reduce((assessment, item) => {
            return { ...assessment, [item.roletype]: false };
          }, {});

        acc[id] = {
          upcoming_appraisal_period: upcomingAppraisalPeriod || {},
          technical_assessment: technicalAssessment || {},
          completedTab: completedtabs,
          appraisarmailid:
            user?.appraisalInformation
              ?.filter((info) => info.appraisal === "Yes")
              ?.map((info) => info.appraiser) || [],
          appraiseeroletype:
            user?.appraisalInformation
              ?.filter((info) => info.appraisal === "Yes")
              ?.map((info) => info.roletype) || [],
          apraiseename: user?.fullname || "",
          apraiseemailid: id,
        };

        return acc;
      }, {}),
    };
    try {
      const obj = {
        contractstatus: status,
        performancecontractname:
          formData?.contractName || transformedData.contractName,
        type: formData?.type || transformedData.type,
        submissionstartdate: formData?.startDate || transformedData.startDate,
        submissionenddate: formData?.endDate || transformedData.endDate,
        agreestatus: "",
        country: isEditing
          ? values.managingoffice
          : formData.managingoffice?.length > 0
          ? formData.managingoffice
          : data?.managingoffice,

        competency: isEditing
          ? values.competencyQC
          : formData.competencyQC?.length > 0
          ? formData.competencyQC
          : data?.competencyQC,

        serviceline: isEditing
          ? values.serviceline
          : formData.serviceline?.length > 0
          ? formData.serviceline
          : data?.serviceline,

        subserviceline: isEditing
          ? values.subserviceline
          : formData.subserviceline?.length > 0
          ? formData.subserviceline
          : data?.subserviceline,

        location: isEditing
          ? values.levellocationid
          : formData.location?.length > 0
          ? formData.location
          : data?.location,

        department: isEditing
          ? values.leveldepartmentname
          : formData.leveldepartmentname?.length > 0
          ? formData.leveldepartmentname
          : data?.leveldepartmentname,

        grade: isEditing
          ? values.grade
          : formData.grade?.length > 0
          ? formData.grade
          : data?.grade,

        userid: userInfo.userid,
        employeeid: getEmployeeList.employeeId,
        individual_appraisals: updatedStepData,
      };
      const apiUrl = isEditing
        ? `appraisal/performancecontract/${selectedRecord}`
        : `appraisal/performancecontract`;
      const { code } = await CALL_API(
        apiUrl,
        isEditing ? "patch" : "post",
        obj
      );

      if (code === STATUS_CODE.SUCCESS) {
        message.success(
          isEditing
            ? "Performance Contract Updated Successfully"
            : "Performance Contract Saved as Draft"
        );
        setEditPerformance(false);
        history.push(`/performancemanagement`, { tabId: 2 });
      } else {
        message.error("Failed to save the contract. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("An error occurred while saving the contract.");
    }
  };

  const handleSaveAndExit = async (values) => {
    setIsCancelModal(false);
    await handleSubmit("draft", values);
  };

  const items = [
    {
      key: 1,
      label: "Basic Info",
    },
    {
      key: 2,
      label: "Targets",
    },
  ];

  const [editActiveTab, setEditActiveTab] = useState(1);
  const onEditTabChange = (key) => {
    if (key === 1) {
      setEditTab(key);
      setActiveKey(key);
      setEditActiveTab(key);
      setStep(0);
    } else {
      setEditTab(key);
      setActiveKey(key);
      setEditActiveTab(key);
      setStep(1);
    }
  };

  return (
    <Styleddiv>
      {isEditing && !isDraft && (
        <Tabs
          activeKey={editActiveTab}
          items={items}
          onChange={onEditTabChange}
        />
      )}
      <div>
        {((!isEditing && !isDraft) || isDraft) && (
          <div className="breadcrumb">
            <p
              className="performance-management"
              onClick={() => {
                showCancelModal();
              }}
            >
              Performance Management
            </p>
            <RightOutlined className="right-icon" />
            <p style={{ fontWeight: "400" }}>Creating Performance</p>
          </div>
        )}

        {((!isEditing && !isDraft) || isDraft) && (
          <StepsProgress stepdata={stepdata} title="" step={step} />
        )}
        {(step === 0 || activeKey === 1) && (
          <>
            <p className="appraisal-people">Contract Information</p>
            <GridBuilder
              formStructureJson={AppraisalInformation}
              handleChange={handleFormChange}
              formSubmit={
                isEditing && !isDraft ? handleSaveChanges : handleNext
              }
              handleSelectChange={handleSelectChange}
              initialValues={isEditing ? transformedData : data}
            />
          </>
        )}

        {(step === 1 || activeKey === 2) && (
          <>
            <CreatingPerformance
              editAppraiseeData={filteredmyteamperformancelist}
              editoverAllAppraiseeData={editoverAllAppraiseeData}
              overAllAppraiseeData={overAllAppraiseeData}
              getAppraiserData={getAppraiserData}
              formData={formData}
              getEmployeeList={getEmployeeList}
              isEditing={isEditing}
              editingformData={transformedData}
              setStep={setStep}
              setEditPerformance={setEditPerformance}
              setIsDraft={setIsDraft}
              isDraft={isDraft}
              datas={data}
              isCancelModal={isCancelModal}
              setIsCancelModal={setIsCancelModal}
            />
          </>
        )}
      </div>
      <StyledModal
        width={500}
        height={220}
        open={step === 0 ? isCancelModal : false}
        onCancel={handleModalCancel}
        footer={[
          <div
            key="footer-buttons"
            style={{ display: "flex", justifyContent: "center", gap: "10px" }}
          >
            <Button className="cancel-modal-button" onClick={handleModalCancel}>
              Cancel
            </Button>
            <Button className="discard-modal-button" onClick={handleDiscard}>
              Discard
            </Button>
            <Button
              key="saveExit"
              type="primary"
              className="save-modal-button"
              onClick={handleSaveAndExit}
            >
              Save & Exit
            </Button>
          </div>,
        ]}
      >
        <CircleWarning className="circle-warning-container" />
        <br />
        <p className="modal-text">
          You haven't completed the performance setup yet. Do you want to save
          the progress before leaving?
        </p>
      </StyledModal>
      <StyledModal
        width={620}
        height={540}
        open={employeeModal}
        onCancel={handleEmpModalCancel}
      >
        <EmployeeSelectStyle>
          <div>
            <Checkbox checked={isAllChecked} onChange={handleSelectAll}>
              All
            </Checkbox>
          </div>
          <div className="employee_select_wrapper">
            {getAllAppraiseeData?.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="employee_select_container">
                    <div className="employee_select_actions">
                      <Checkbox
                        onChange={(e) => handleClickCheckbox(e, item)}
                        checked={getSelectedData.some(
                          (selected) => selected.employeeid === item.employeeid
                        )}
                      />
                      <p>{item?.fullname}</p>
                    </div>
                    <div>
                      <p>{`${item?.employeeid}`}</p>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </EmployeeSelectStyle>
      </StyledModal>
    </Styleddiv>
  );
};

const mapStateToProps = (state) => ({
  supervisorList: getSupervisorList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(PerformanceContract);

const EmployeeSelectStyle = styled.div`
  .employee_select_wrapper {
    border-top: 1px solid #000;
  }
  .employee_select_container {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .employee_select_actions {
    display: flex;
    gap: 10px;
  }
`;
